import { render, staticRenderFns } from "./PacksList.vue?vue&type=template&id=1a4d73af&"
import script from "./PacksList.vue?vue&type=script&lang=js&"
export * from "./PacksList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports